import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Button, FormGroup, Label, Input } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import "../stylesheets/style.scss";
import { Project_APIs } from "./Project_APIs";
import { Project_Variables } from "./Project_Variables";
import { UserConsumer } from "../../UserContext";
import { Redirect } from "react-router-dom";
import FormStatus from "../../components/FormStatus";
import CustomReactSelect from "../../components/CustomReactSelect";
import { AlertPopups } from "../../components/AlertPopups";
import { Routes } from "../../configurations/config";
const validation = Yup.object().shape({
	projectName: Yup.string()
		.max(50, "Max 50 characters allowed")
		.required("Name can't be empty"),
	devOpsName: Yup.string()
		.max(255, "Max 255 characters allowed")
		.required("Name can't be empty"),
	areaPath: Yup.string()
		.max(255, "Max 255 characters allowed")
		.required("Area path can't be empty"),
	projectType: Yup.string().required("Project type cannot be empty"),
	Notes: Yup.string().max(500, "Max 500 characters allowed"),
});
let token = null;
class CreateProject extends Component {
	constructor(props) {
		super(props);

		this.state = {
			projectName: "",
			projectType: "",
			supervisor: "",
			allocateTo: "",
			Notes: "",
			date: new Date().toDateString(),
			supervisorsList: [],
			allocateToList: [],
			allProjectsDetail: [],
			projectTypeList: [],
			nameErr: false,
			totalRecords: 0,
			success: false,
			devOpsName: "",
			areaPath: "",
		};
	}

	supervisorsListValues() {
		return this.state.supervisorsList.map((data) => ({
			label: data.name,
			value: data.employeeId,
		}));
	}
	allocatedToListValues() {
		return this.state.allocateToList.map((data) => ({
			label: data.name,
			value: data.employeeId,
		}));
	}
	projectTypeValues() {
		return this.state.projectTypeList.map((data) => ({
			label: data.projectType,
			value: data.id,
		}));
	}
	componentDidMount() {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(`${Project_APIs.GetProjectType_API}`, { headers: headers })
			.then((res) => {
				this.setState({ projectTypeList: res.data });
			});
		axios
			.get(`${Project_APIs.GetSupervisors_API}`, { headers: headers })
			.then((res) => {
				this.setState({ supervisorsList: res.data });
			});
		axios
			.get(`${Project_APIs.GetAllEmployeesWithCode_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({ allocateToList: res.data });
			});
		axios
			.get(`${Project_APIs.GetAllProjects_API}`, { headers: headers })
			.then((res) => {
				this.setState({
					allProjectsDetail: res.data,
					totalRecords: res.data.length,
				});
			});
	}
	handleChange = (temp, displayCode, event) => {
		if (displayCode === 1 || displayCode === 5) {
			this.setState({
				[temp.target.name]: temp.target.value,
			});
		} else if (
			displayCode === 2 ||
			displayCode === 3 ||
			displayCode === 4
		) {
			this.setState({
				[event.name]: temp,
			});
		}
	};
	handleBlur = (event) => {
		this.setState({ nameErr: false });
		if (event.target.value !== null || event.target.value !== "") {
			for (let i = 0; i < this.state.totalRecords - 1; i++) {
				if (
					this.state.allProjectsDetail[
						i
					].projectDetails.projectName.toLowerCase() !==
					event.target.value.toLowerCase()
				) {
					continue;
				} else {
					this.setState({ nameErr: true });
					return;
				}
			}
		}
	};

	handleSubmit = (values) => {
		if (this.state.nameErr === false) {
			let allocateToIds = [];

			if (this.state.allocateTo) {
				this.state.allocateTo.forEach((element) => {
					allocateToIds.push(element.value);
				});
			}
			let self = this;
			let data = {
				ProjectName: values.projectName,
				devopsProjectName: values.devOpsName,
				devopsAreaPath: values.areaPath,
				Employees: allocateToIds,
				ProjectCategory:
					values.projectType !== null
						? values.projectType.value
						: null,
				SupervisorId:
					values.supervisor !== null ? values.supervisor.value : null,
				Notes: values.Notes,
			};
			const headers = {
				Authorization: `Bearer ${token}`,
			};
			axios
				.post(`${Project_APIs.CreateProject_API}`, data, {
					headers: headers,
				})
				.then(function (response) {
					if (response.status === 200) {
						AlertPopups.successAlert.fire({
							text: `${Project_Variables.createProjectMsg}`,
						});
						self.props.history.push(Routes.ProjectListing);
					}
				})
				.catch((error) => {
					AlertPopups.WarningAlert.fire({
						text: `Try again please`,
					});
				});
		}
	};

	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;

					return userDetails.designation.toString() === "4" ||
						userDetails.id.toString() === "180" ||
						userDetails.id.toString() === "269" ? (
						<div className="container-fluid pl-4 pr-4">
							<FormStatus
								title="Create Project"
								className="create-request d-flex align-items-center"
								onClick={() => {
									this.props.history.push(
										Routes.ProjectListing
									);
								}}
								navigateBack={true}
							/>
							<Formik
								initialValues={this.state}
								validationSchema={validation}
								validateOnChange={true}
								enableReinitialize={true}
								onSubmit={(values) => this.handleSubmit(values)}
							>
								{({ errors, handleBlur, handleSubmit }) => (
									<form
										onSubmit={handleSubmit}
										className="itemReqForm"
									>
										<FormGroup
											row
											id="row0"
											className="bottom-spacing topBorders"
										>
											<Label sm={12}>
												Create Project
											</Label>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label for="projectName" sm={2}>
												Project Name
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<Input
													type="text"
													value={
														this.state.projectName
													}
													placeholder="Type Project Name"
													name="projectName"
													id="projectName"
													bsSize="sm"
													autoComplete="off"
													onChange={(value, event) =>
														this.handleChange(
															value,
															1,
															event
														)
													}
													className={
														errors.projectName
															? "invalid"
															: ""
													}
													onBlur={this.handleBlur}
													maxLength="50"
												/>

												{this.state.nameErr && (
													<div className="input-feedback">
														Project name already
														used, please use some
														other name.
													</div>
												)}
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2"
										>
											<Label for="devOpsName" sm={2}>
												DevOps Name
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={4}>
												<Input
													type="text"
													value={
														this.state.devOpsName
													}
													placeholder="Type Project's devOps Name"
													name="devOpsName"
													id="devOpsName"
													bsSize="sm"
													autoComplete="off"
													onChange={(value, event) =>
														this.handleChange(
															value,
															1,
															event
														)
													}
													className={
														errors.devOpsName
															? "invalid"
															: ""
													}
													maxLength="255"
												/>
											</Col>
											<Label for="areaPath" sm={2}>
												DevOps Area path
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={4}>
												<Input
													type="text"
													value={this.state.areaPath}
													placeholder="Type Project's devOps area path"
													name="areaPath"
													id="areaPath"
													bsSize="sm"
													autoComplete="off"
													onChange={(value, event) =>
														this.handleChange(
															value,
															1,
															event
														)
													}
													className={
														errors.areaPath
															? "invalid"
															: ""
													}
													maxLength="255"
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label for="projectType" sm={2}>
												Project Type
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													placeholder="Presales, Inhouse, Fixed term"
													options={this.projectTypeValues()}
													name="projectType"
													id="projectType"
													styles={
														Project_Variables.react_select_style
													}
													bsSize="sm"
													onChange={(value, event) =>
														this.handleChange(
															value,
															2,
															event
														)
													}
													isClearable
													value={
														this.state.projectType
													}
													className={
														errors.projectType
															? "invalid"
															: ""
													}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2"
										>
											<Label for="supervisorsList" sm={2}>
												Supervisor
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={this.supervisorsListValues()}
													name="supervisor"
													styles={
														Project_Variables.react_select_style
													}
													id="supervisor"
													placeholder=""
													onChange={(value, event) =>
														this.handleChange(
															value,
															3,
															event
														)
													}
													value={
														this.state.supervisor
													}
													bsSize="sm"
													onBlur={handleBlur}
													isClearable
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label for="allocateToList" sm={2}>
												Team
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={this.allocatedToListValues()}
													multipule={true}
													placeholder=""
													name="allocateTo"
													styles={
														Project_Variables.react_multiselect_style
													}
													id="allocateTo"
													onChange={(value, event) =>
														this.handleChange(
															value,
															4,
															event
														)
													}
													value={
														this.state.allocateTo
													}
													bsSize="sm"
													onBlur={handleBlur}
													isClearable
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="rowStyle2 bottom-spacing lastRow"
										>
											<Label for="Notes" sm={2}>
												Add Notes
											</Label>
											<Col sm={10}>
												<Input
													type="textarea"
													name="Notes"
													id="Notes"
													onChange={(value, event) =>
														this.handleChange(
															value,
															5,
															event
														)
													}
													className="h-auto"
													onBlur={handleBlur}
													value={this.state.Notes}
													maxLength="500"
												/>
											</Col>
										</FormGroup>

										<div className="btns mt-4">
											<Button
												className="submit-btn"
												type="Submit"
												hidden={
													this.state.disableChange
												}
											>
												Create
											</Button>
										</div>
									</form>
								)}
							</Formik>
						</div>
					) : (
						<Redirect to="/MyDashboard" />
					);
				}}
			</UserConsumer>
		);
	}
}
export default CreateProject;
